var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.img,"alt":"二维码"}}),_c('p',[_vm._v("长按保存二维码")])])}
var staticRenderFns = []

export { render, staticRenderFns }